const Enviroment = {
  stage: process.env.STAGE || "dev",
  endpoint: process.env.ENDPOINT || "/api"
};
export default Enviroment;